export const convertirPeriodo = (periodo) => {
  if (!periodo || !/^\d{2}-\d{4}$/.test(periodo)) return periodo

  const [mes, anio] = periodo.split('-')
  return `${anio}${mes}`
}

export const formatearPeriodoVisual = (periodo) => {
  if (!periodo || !/^\d{6}$/.test(periodo)) return periodo

  const anio = periodo.slice(0, 4)
  const mes = periodo.slice(4, 6)
  return `${anio}-${mes}`
}
